import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { FaChevronRight } from '@react-icons/all-files/fa/FaChevronRight';

import { ContactMessageEntry } from '../../../../../../services/marketplace/generated/kubb/models/ContactMessageEntry';
import { MarketplaceOffer } from '../offers/utils';
import ConversationIcon from './ConversationIcon';
import { MessagePreview, PLATFORM_LABEL, getMessagePreview, getUnreadCount } from './utils';

type ConversationDoorwayProps = {
  thread: ContactMessageEntry[] | undefined;
  history: MarketplaceOffer[];
  onOpen: () => void;
};

const SENDER_PREFIX: Record<MessagePreview['senderRole'], string> = {
  dealer: 'Buyer:',
  driver: 'You:',
  platform: `${PLATFORM_LABEL}:`,
};

// The conversation entry point: a full-width row below the offer that previews the latest message
// or offer note (or prompts to start one) and opens that dealer's conversation. Shown on every
// breakpoint.
const ConversationDoorway = ({ thread, history, onOpen }: ConversationDoorwayProps) => {
  const preview = getMessagePreview(thread, history);
  const unreadCount = getUnreadCount(thread, history);

  return (
    <Flex
      as="button"
      type="button"
      onClick={onOpen}
      align="center"
      gap="10px"
      w="100%"
      mt="14px"
      px="14px"
      py="11px"
      borderWidth="1px"
      borderColor="gainsboro"
      borderRadius="9px"
      bg="white"
      textAlign="left"
      _hover={{ bg: 'blackAlpha.50', borderColor: 'leaseEndBlue' }}
    >
      <ConversationIcon unreadCount={unreadCount} />
      {preview ? (
        <Text fontSize="13px" color="grayDark" noOfLines={1} flex="1" minW={0}>
          <Text as="span" fontWeight="700" color="leaseEndBlue">
            {SENDER_PREFIX[preview.senderRole]}
          </Text>{' '}
          {preview.text}
        </Text>
      ) : (
        <Text fontSize="13px" fontWeight="600" color="leaseEndBlue" flex="1" minW={0}>
          Message the buyer
        </Text>
      )}
      <Box as="span" color="grayMedium" flexShrink={0}>
        <Icon as={FaChevronRight} boxSize="12px" />
      </Box>
    </Flex>
  );
};

export default ConversationDoorway;
